import { Button } from "../ui/button";
import { PaginationEllipsis } from "../ui/pagination";

export const renderPageButtons = (totalCount: number, perPage: number, currentPage: number, setCurrentPage: (page: number) => void) => {
  const totalPages = Math.ceil(totalCount / perPage);
  const pages: (number | string)[] = [];

  // Trang đầu
  pages.push(1);

  // Thêm "..." nếu currentPage > 3
  if (currentPage > 3) {
    pages.push("ellipsis-left");
  }

  // Các trang xung quanh currentPage
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(totalPages - 1, currentPage + 1);
    i++
  ) {
    pages.push(i);
  }

  // Thêm "..." nếu currentPage < totalPages - 2
  if (currentPage < totalPages - 2) {
    pages.push("ellipsis-right");
  }

  // Trang cuối (nếu > 1)
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages.map((page, index) =>
    typeof page === "number" ? (
      <Button
        key={index}
        onClick={() => setCurrentPage(page)}
        className={`hover:bg-white hover:border hover:border-red-500 hover:text-red-500 ${
          currentPage === page
            ? "bg-white text-red-500 border border-red-500"
            : ""
        }`}
        variant="ghost"
        size="icon"
      >
        {page}
      </Button>
    ) : (
      <PaginationEllipsis key={index} />
    )
  );
};